import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import sanityClient from '../../../sanityClient';
import '../../../assets/css/views/blog.css';

const BlogIndex = () => {
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    sanityClient
      .fetch(
        `*[_type == "post"] | order(publishedAt desc) {
          title,
          slug,
          excerpt,
          publishedAt,
          "authorName": author->name,
          "categories": categories[]->title
        }`
      )
      .then((data) => setPosts(data))
      .catch(console.error);
  }, []);

  if (!posts) {
    return <div>Loading...</div>;
  }

  return (
    <div className="blog-container">
      <div className="blog-hero">
        <h1>The Amplify Loyalty Blog</h1>
        <p>Expert insights on customer loyalty, retention marketing, and e-commerce growth.</p>
      </div>
      <div className="posts-grid">
        {posts && posts.map((post) => (
          <Link to={`/blog/${post.slug.current}`} key={post.slug.current} className="post-card">
            <div className="card-top">
              {post.categories && (
                <p className="card-categories">{post.categories.join(', ')}</p>
              )}
              <h2 className="card-title">{post.title}</h2>
            </div>
            {post.excerpt && (
              <div className="card-bottom">
                <p className="card-description">{post.excerpt}</p>
                <div className="card-meta">
                  <span className="meta-author">{post.authorName}</span>
                  <span className="meta-date">{new Date(post.publishedAt).toLocaleDateString()}</span>
                </div>
              </div>
            )}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default BlogIndex;

